
import {
  defineComponent,
  reactive,
  toRefs,
  computed,
  watch,
  onMounted,
  onUnmounted,
  PropType
} from "vue";
import QRCode from "qrcode";
import { formatDateTime } from "../../modules/utils";
import { useToast } from "../../modules/message";
import {
  formatMoeda,
  formatTempoRestante
} from "../../modules/business/rntrc/rntrcTypes";

interface RntrcPixState {
  qrCodeUrl: string | null;
  agora: Date;
  interval?: number | null;
}

export default defineComponent({
  setup(props) {
    const state = reactive<RntrcPixState>({
      qrCodeUrl: null,
      agora: new Date(),
      interval: null
    });

    const gerarQrCode = () => {
      state.qrCodeUrl = null;
      if (props.codigoPix) {
        QRCode.toDataURL(props.codigoPix, {
          errorCorrectionLevel: "M",
          margin: 1,
          width: 220
        })
          .then((url: string) => {
            state.qrCodeUrl = url;
          })
          .catch(() => {
            state.qrCodeUrl = null;
          });
      }
    };

    const vencido = computed(
      () =>
        !!props.dataVencimentoPix &&
        props.dataVencimentoPix.getTime() <= state.agora.getTime()
    );

    const tempoRestante = computed(() =>
      formatTempoRestante(props.dataVencimentoPix, state.agora)
    );

    const copiarCodigo = () => {
      if (props.codigoPix) {
        window.navigator.clipboard.writeText(props.codigoPix);
        useToast().success("Código PIX copiado!");
      }
    };

    watch(
      () => props.codigoPix,
      () => gerarQrCode()
    );

    onMounted(() => {
      gerarQrCode();
      state.interval = window.setInterval(() => {
        state.agora = new Date();
      }, 30 * 1000);
    });

    onUnmounted(() => {
      if (state.interval) {
        clearInterval(state.interval);
        state.interval = null;
      }
    });

    return {
      vencido,
      tempoRestante,
      copiarCodigo,
      formatDateTime,
      formatMoeda,
      ...toRefs(state)
    };
  },
  props: {
    codigoPix: String,
    valorPix: Number,
    dataVencimentoPix: Object as PropType<Date>
  }
});
